export default __webpack_public_path__ + "static/media/wi-day-thunderstorm.4dd82b3f.svg";